module.exports = __webpack_public_path__ + "static/img/87008A_2_3_R_20190804_LC.b84ee0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87008A_2_3_R_20190804_LC.png
// module id = I2Q+
// module chunks = 0